import InventoryScreenType from "../screenTypes/functional/InventoryScreenType";

function MaterialInventoryManage(props) {

  return (
    <InventoryScreenType id ="MaterialInventory" table ="MaterialInOutput" view ="VwMaterialInventory"/> 
  )
}
export default MaterialInventoryManage;
